import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FilesViewerModalComponent } from '@app/shared/components/files-viewer-modal/files-viewer-modal.component';
import { DriverService } from '@app/services/driver.service';

@Component({
  selector: 'app-step-accident-details',
  templateUrl: './step-accident-details.component.html',
  styleUrls: ['./step-accident-details.component.scss'],
  standalone: false,
})
export class StepAccidentDetailsComponent implements OnInit {
  @Input() accidentDetailsForm!: FormGroup;
  @Output() filesChanged = new EventEmitter<File[]>();

  assetsOptions: any[] = [];
  crashTypeOptions: any[] = [];

  selectedFiles: File[] = [];
  imageUrls: string[] = [];
  imageFileNames: string[] = [];

  constructor(private driverService: DriverService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.getAssetLocationList();
    this.getCrashTypeList();
  }

  getAssetLocationList(): void {
    this.driverService.getAccidentOptionsList('AssetLocation').subscribe({
      next: (res) => {
        this.assetsOptions = res.sort((a: any, b: any) => a.id - b.id);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getCrashTypeList(): void {
    this.driverService.getAccidentOptionsList('CrashType').subscribe({
      next: (res) => {
        this.crashTypeOptions = res.sort((a: any, b: any) => a.id - b.id);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  private handleFiles(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type.startsWith('image/')) {
        this.selectedFiles.push(file);
        this.imageFileNames.push(file.name);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageUrls.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
    // Emit the updated files array to parent component
    this.filesChanged.emit(this.selectedFiles);
  }

  removeImage(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.imageUrls.splice(index, 1);
    this.imageFileNames.splice(index, 1);
    // Emit the updated files array to parent component
    this.filesChanged.emit(this.selectedFiles);
  }

  // Method to get selected files (for parent component to access)
  getSelectedFiles(): File[] {
    return this.selectedFiles;
  }

  openFileViewer(index: number): void {
    this.dialog.open(FilesViewerModalComponent, {
      height: 'calc(100% - 30px)',
      width: 'calc(100% - 30px)',
      maxWidth: '100%',
      maxHeight: '100%',
      data: { urls: this.imageUrls, currentIndex: index },
      panelClass: 'files-viewer-modal-custom',
    });
  }
}
